"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveFileAsPng = void 0;
const buffer_1 = require("buffer");
const base64ToFile = (base64, fileName) => {
    const buffer = buffer_1.Buffer.from(base64.split(',')[1], 'base64');
    return new File([buffer], fileName, { type: '.png' });
};
const saveFileAsPng = (base64, fileName) => {
    const imgFile = base64ToFile(base64, fileName);
    let anchor = document.createElement('a');
    anchor.download = fileName;
    anchor.href = window.URL.createObjectURL(imgFile);
    anchor.click();
};
exports.saveFileAsPng = saveFileAsPng;
